import { Injectable } from '@angular/core';
import { AbstractControl, ValidatorFn } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class CustomvalidationService {

  constructor() { }
  requiredValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (control.value.trim().length != 0) {
        return null;
      }
      return { required: true };
    };
  }

  emailValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      var email = control.value.trim();
      var checkTLD = 1;
      var knownDomsPat = /^(com|net|org|edu|int|mil|gov|arpa|biz|aero|name|coop|info|pro|museum)$/;
      var emailPat = /^(.+)@(.+)$/;
      var specialChars = "\\(\\)><@,;:\\\\\\\"\\.\\[\\]";
      var validChars = "\[^\\s" + specialChars + "\]";
      var quotedUser = "(\"[^\"]*\")";
      var ipDomainPat = /^\[(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})\]$/;
      var atom = validChars + '+';
      var word = "(" + atom + "|" + quotedUser + ")";
      var emailStr = email.toLowerCase();
      // The following pattern describes the structure of the user
      var userPat = new RegExp("^" + word + "(\\." + word + ")*$");
      /* The following pattern describes the structure of a normal symbolic
      domain, as opposed to ipDomainPat, shown above. */

      var domainPat = new RegExp("^" + atom + "(\\." + atom + ")*$");

      /* Finally, let's start trying to figure out if the supplied address is valid. */

      /* Begin with the coarse pattern to simply break up user@domain into
      different pieces that are easy to analyze. */


      // return null if email field is optional
      // if email field is required use requiredValidator() along with this validator
      if (email.trim().length === 0) {
        return null;
      }

      var matchArray = emailStr.match(emailPat);

      if (matchArray == null) {

        /* Too many/few @'s or something; basically, this address doesn't
        even fit the general mould of a valid e-mail address. */
        return { invalidAtDot: true };
      }
      var user = matchArray[1];
      var domain = matchArray[2];

      // Start by checking that only basic ASCII characters are in the strings (0-127).

      for (i = 0; i < user.length; i++) {
        if (user.charCodeAt(i) > 127) {
          return { invalidEmailChar: true };
        }
      }
      for (i = 0; i < domain.length; i++) {
        if (domain.charCodeAt(i) > 127) {
          return { invalidEmailDomain: true };
        }
      }

      // See if "user" is valid 

      if (user.match(userPat) == null) {

        // user is not valid
        return { invalidEmailUserName: true };
      }

      /* if the e-mail address is at an IP address (as opposed to a symbolic
      host name) make sure the IP address is valid. */

      var IPArray = domain.match(ipDomainPat);
      if (IPArray != null) {

        // this is an IP address

        for (var i = 1; i <= 4; i++) {
          if (IPArray[i] > 255) {
            return { invalidEmailIp: true };
          }
        }
        return null;
      }

      // Domain is symbolic name.  Check if it's valid.

      var atomPat = new RegExp("^" + atom + "$");
      var domArr = domain.split(".");
      var len = domArr.length;
      for (i = 0; i < len; i++) {
        if (domArr[i].search(atomPat) == -1) {
          return { invalidDomainName: true };
        }
      }

      /* domain name seems valid, but now make sure that it ends in a
      known top-level domain (like com, edu, gov) or a two-letter word,
      representing country (uk, nl), and that there's a hostname preceding 
      the domain or country. */

      if (checkTLD && domArr[domArr.length - 1].length != 2 &&
        domArr[domArr.length - 1].search(knownDomsPat) == -1) {
        return { invalidDomainOrCountry: true };
      }

      // Make sure there's a host name preceding the domain.

      if (len < 2) {
        return { missingEmailHost: true };
      }

      // If we've gotten this far, everything's valid!
      return null;
    }
  }
}